import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import isEqual from "fast-deep-equal/es6";
import { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";
import { REPORT_PANEL, RReport } from "../ca/report/Report";
import { SectionBase } from "../ca/report/sections/SectionBase";
import { SectionBuild } from "../ca/report/sections/SectionBuild";
import { SectionHero } from "../ca/report/sections/SectionHero";
import { SectionHeader } from "../ca/report/sections/util";
import { useSelection } from "../ca/state";

const ReportData = ({ location }) => {
  const gps = useMemo(() => {
    if (!location) return;
    return location.split(",").map(parseFloat);
  }, [location]);
  const [selectedGPS, cube, state, selectGPS] = useSelection(
    useShallow((s) => [s.gps, s.cube, s.state, s.selectGPS])
  );
  useEffect(() => {
    if (gps && !isEqual(gps, selectedGPS)) {
      selectGPS(gps);
    }
  }, [gps, selectGPS, selectedGPS]);

  if (state !== "fetched") {
    return (
      <div className="shrink bg-white">
        <SectionHero field={cube} />
        <div className="p-4 flex flex-col">
          <SectionHeader
            icon={
              <FontAwesomeIcon
                icon={faSpinner}
                className="w-4 h-4 animate-spin-slow"
                fill="green"
              />
            }
            title={state === "fetching" ? "Loading..." : "Error..."}
          />
        </div>
        <div className="bg-white h-full" />
      </div>
    );
  }
  return (
    <div className="shrink">
      <SectionHero field={cube} />
      <div className="p-4 flex flex-col">
        <SectionBase field={cube} />
        <SectionBuild field={cube} />
        <div className="bg-white h-[calc(100vh-260px)]" />
      </div>
    </div>
  );
};

const mp = { base: "" };
export const Report = () => {
  const [p0, p1] = useParams()["*"].split("/");
  const navigate = useNavigate();
  const updateSection = useMemo(
    () => (section: string) => {
      if (p1 !== section) navigate(`/location/${mp[p0] || p0}/${section}`, { replace: true });
    },
    [navigate, p0, p1]
  );

  return (
    <RReport
      location={p0}
      updateSection={updateSection}
      className={`relative sm:w-[24rem] lg:w-108 flex z-10 ${REPORT_PANEL}`}
      Component={ReportData}
    />
  );
};
